import React, { Fragment } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Logo from "../assets/img/logo.png";

export default function Sidebar() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate("/"); // Redirige al login
    };

    return (
        <Fragment>
            <aside className='d-flex'>
                <div>
                    <div className='side-logo'>
                        {/* <img 
                        src={Logo}
                        alt='Logo'
                        width={110}
                        /> */}
                    </div>
                    <ul className='nav flex-column gap-2'>
                        <li className="nav-item">
                            <Link to="/dashboard"><span className="size-mat material-symbols-outlined">home_app_logo</span> </Link>
                        </li>
                        <li className="nav-item">
                            
                            <Link to="/salario"><span className="size-mat material-symbols-outlined">attach_money</span> </Link> 
                        </li>
                        <li className="nav-item">
                            
                            <Link to="/gasto"><span className="size-mat material-symbols-outlined">wallet</span></Link>
                        </li>
                        <li className="nav-item">
                            
                            <Link to="/historial"><span className="size-mat material-symbols-outlined">manage_history</span> </Link> 
                        </li>
                        <li className="nav-item">
                            
                            <Link to="/extra"><span className="size-mat material-symbols-outlined">savings</span></Link>
                        </li>
                        <li className="nav-item">

                            {user && (
                                <button onClick={handleLogout} style={{ background: "none", border: "none", color: "blue", cursor: "pointer" }}>
                                  <span className="size-mat material-symbols-outlined">exit_to_app</span> 
                                </button>
                            )}
                        </li>
                    </ul>
                </div>
            </aside>
        </Fragment>
    )
}
